import { render } from "./CloneUser.vue?vue&type=template&id=5dd66858"
import script from "./CloneUser.vue?vue&type=script&lang=js"
export * from "./CloneUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__